import { generateUrl as u } from "@nextcloud/router";
/* empty css                                                                           */import { n as p } from "./_plugin-vue2_normalizer-71e2aa87.mjs";
import { L as m } from "./Linkify-39f20c9a.mjs";
import d from "escape-html";
import a from "striptags";
import b from "vue";
const _ = {
  name: "NcMentionBubble",
  props: {
    id: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    icon: {
      type: String,
      required: !0
    },
    iconUrl: {
      type: [String, null],
      default: null
    },
    source: {
      type: String,
      required: !0
    },
    primary: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    avatarUrl() {
      return this.iconUrl ? this.iconUrl : this.id && this.source === "users" ? this.getAvatarUrl(this.id, 44) : null;
    },
    mentionText() {
      return !this.id.includes(" ") && !this.id.includes("/") ? `@${this.id}` : `@"${this.id}"`;
    }
  },
  methods: {
    getAvatarUrl(t, e) {
      return u("/avatar/{user}/{size}", {
        user: t,
        size: e
      });
    }
  }
};
var g = function() {
  var e = this, n = e._self._c;
  return n("span", { staticClass: "mention-bubble", class: { "mention-bubble--primary": e.primary }, attrs: { contenteditable: "false" } }, [n("span", { staticClass: "mention-bubble__wrapper" }, [n("span", { staticClass: "mention-bubble__content" }, [n("span", { staticClass: "mention-bubble__icon", class: [e.icon, `mention-bubble__icon--${e.avatarUrl ? "with-avatar" : ""}`], style: e.avatarUrl ? { backgroundImage: `url(${e.avatarUrl})` } : null }), n("span", { staticClass: "mention-bubble__title", attrs: { role: "heading", title: e.title } })]), n("span", { staticClass: "mention-bubble__select", attrs: { role: "none" } }, [e._v(e._s(e.mentionText))])])]);
}, f = [], h = /* @__PURE__ */ p(
  _,
  g,
  f,
  !1,
  null,
  "357e6d0e",
  null,
  null
);
const y = h.exports;
/**
 * @copyright Copyright (c) 2020 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const o = "(?:^|\\s)", l = "(?:[^a-z]|$)", E = new RegExp(`${o}(@[a-zA-Z0-9_.@\\-']+)(${l})`, "gi"), $ = new RegExp(`${o}(@&quot;[a-zA-Z0-9 _.@\\-']+&quot;)(${l})`, "gi"), R = {
  props: {
    userData: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    /**
     * Convert the value string to html for the inner content
     *
     * @param {string} value the content without html
     * @return {string} rendered html
     */
    renderContent(t) {
      return d(t).split(E).map((r) => r.split($)).flat().map((r) => {
        if (!r.startsWith("@"))
          return m(r);
        const i = r.slice(1).replace(/&quot;/gi, "");
        return " " + this.genSelectTemplate(i);
      }).join("").replace(/\n/gmi, "<br>").replace(/&amp;/gmi, "&");
    },
    /**
     * Convert the innerHtml content to a string with mentions as text
     *
     * @param {string} content the content without html
     * @return {string}
     */
    parseContent(t) {
      let e = t.replace(/<br>/gmi, `
`);
      return e = e.replace(/&nbsp;/gmi, " "), e = e.replace(/&amp;/gmi, "&"), e = e.replace(/<\/div>/gmi, `
`), e = a(e, "<div>"), e = a(e), e;
    },
    /**
     * Generate an autocompletion popup entry template
     *
     * @param {string} value the value to match against the userData
     * @return {string}
     */
    genSelectTemplate(t) {
      if (typeof t > "u")
        return `${this.autocompleteTribute.current.collection.trigger}${this.autocompleteTribute.current.mentionText}`;
      const e = this.userData[t];
      return e ? this.renderComponentHtml(e, y).replace(/[\n\t]/gmi, "") : !t.includes(" ") && !t.includes("/") ? `@${t}` : `@"${t}"`;
    },
    /**
     * Render a component and return its html content
     *
     * @param {object} propsData the props to pass to the component
     * @param {object} component the component to render
     * @return {string} the rendered html
     */
    renderComponentHtml(t, e) {
      const n = b.extend(e), r = new n({
        propsData: t
      }), i = document.createElement("div"), s = document.createElement("div");
      i.style.display = "none", i.appendChild(s), document.body.appendChild(i), r.$mount(s);
      const c = i.innerHTML;
      return r.$destroy(), i.remove(), c;
    }
  }
};
export {
  y as N,
  E as U,
  $ as a,
  R as r
};
